import { render, staticRenderFns } from "./ProjectLogs.vue?vue&type=template&id=2166108a&"
import script from "./ProjectLogs.vue?vue&type=script&lang=js&"
export * from "./ProjectLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports